import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { SuwasthiLoader } from "../components/loader";
import { useUser } from "../config/userProvider";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoArrowBack } from "react-icons/io5";
import { motion } from "framer-motion";
import io from "socket.io-client";
import { useSocket } from "../config/socketContext";
import Breadcrumb from "../components/breadcrumb";
import {
  ChangeInterviewStatusButton,
  ChangeStatusButton,
} from "../components/changeStatusButton";
import dayjs from "dayjs";
import ManagerAssignCard from "../components/managerAssignCard";
import { getCookie } from "../config/webStorage";
import { GoInfo } from "react-icons/go";
import { FaEdit } from "react-icons/fa";
import DatePicker from "react-datepicker";
import {
  FileText,
  Phone,
  Mail,
  User,
  Briefcase,
  Building2,
  Calendar,
  Hash,
  IdCard,
} from "lucide-react";

const ManageApplication = () => {
  const { userData } = useUser();
  const [editMode, setEditMode] = useState(false);
  const { applicationObjId } = useParams();
  const [application, setApplication] = useState(null);
  const [applicationData, setApplicationData] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [feedback, setFeedback] = useState("");
  const navigate = useNavigate();
  const { messages, sendMessage, typingStatus } = useSocket();
  const [updatedApplication, setUpdatedApplication] =
    useState(applicationObjId);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [documentLink, setDocumentLink] = useState("");

  useEffect(() => {
    fetchApplication();
    // fetchUsers();
  }, [applicationObjId]);

  const fetchApplication = async () => {
    try {
      const response = await axios.get(
        `${apiurl}/api/application/get/${applicationObjId}`
      );
      setApplication(response?.data?.application);
      setApplicationData(response?.data);
    } catch (error) {
      console.error("Error fetching application:", error);
    } finally {
      setLoading(false);
    }
  };
  const openModal = (link) => {
    setDocumentLink(link);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setDocumentLink("");
  };

  // const fetchUsers = async () => {
  //   try {
  //     const response = await axios.get("/api/users");
  //     setUsers(response.data);
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //   }
  // };

  const handleDelete = async (applicationObjId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this application?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`${apiurl}/api/application/delete`, {
        data: { applicationObjId }, // 👈 send data in body like this
      });

      // Optionally remove from UI list
      // setApplications((prev) => prev.filter((a) => a._id !== applicationObjId));

      // alert("Application deleted successfully.");
      toast.success("Status updated successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      navigate("/applications");
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete application.");
    }
  };

  const sendCanceled = async (applicationObjId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to send canceled this application?"
    );
    if (!confirmDelete) return;

    try {
      await axios.post(`${apiurl}/api/application/send-canceled-mail`, {
        applicationObjId, // 👈 send data in body like this
      });

      // Optionally remove from UI list
      // setApplications((prev) => prev.filter((a) => a._id !== applicationObjId));

      // alert("Application deleted successfully.");
      toast.success("Send mail successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      navigate("/past-joining");
    } catch (err) {
      console.error("error:", err);
      alert("Failed to send mail.");
    }
  };

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editData, setEditData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    dateOfBirth: "",
    positionTitle: "",
    department: "",
    applicationStatus: "",
  });
  useEffect(() => {
    if (application) {
      setEditData({
        id: application._id || "",
        firstName: application?.candidateSnapshot?.firstName || "",
        lastName: application?.candidateSnapshot?.lastName || "",
        email: application?.candidateSnapshot?.email || "",
        phone: application?.candidateSnapshot?.phone || "",
        gender: application?.candidateSnapshot?.gender || "",
        dateOfBirth: application?.candidateSnapshot?.dateOfBirth || "",
        positionTitle: application?.positionTitle || "",
        department: application?.department || "",
        applicationStatus: application?.applicationStatus || "",
      });
    }
  }, [application]);

  console.log("editData", editData);
  console.log("application", application);

  if (loading) {
    return <SuwasthiLoader />;
  }

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <Breadcrumb page="Manage Application" />

        {isEditOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-xl p-6 w-full max-w-2xl shadow-lg">
              <h3 className="text-lg font-bold mb-4">
                Edit Candidate & Application Details (ID: {editData.id})
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <input
                  placeholder="First Name"
                  value={editData.firstName}
                  onChange={(e) =>
                    setEditData({ ...editData, firstName: e.target.value })
                  }
                  className="border rounded p-2 w-full"
                />
                <input
                  placeholder="Last Name"
                  value={editData.lastName}
                  onChange={(e) =>
                    setEditData({ ...editData, lastName: e.target.value })
                  }
                  className="border rounded p-2 w-full"
                />
                <input
                  placeholder="Email"
                  value={editData.email}
                  onChange={(e) =>
                    setEditData({ ...editData, email: e.target.value })
                  }
                  className="border rounded p-2 w-full"
                />
                <input
                  placeholder="Phone"
                  value={editData.phone}
                  onChange={(e) =>
                    setEditData({ ...editData, phone: e.target.value })
                  }
                  className="border rounded p-2 w-full"
                />
                <select
                  value={editData.gender}
                  onChange={(e) =>
                    setEditData({ ...editData, gender: e.target.value })
                  }
                  className="border rounded p-2 w-full"
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
                <DatePicker
                  selected={
                    editData.dateOfBirth ? new Date(editData.dateOfBirth) : null
                  }
                  onChange={(date) =>
                    setEditData({
                      ...editData,
                      dateOfBirth: date?.toISOString(),
                    })
                  }
                  placeholderText="Date of Birth"
                  className="border rounded p-2 w-full"
                  dateFormat="yyyy-MM-dd"
                />
                <select
                  value={editData.positionTitle}
                  onChange={(e) =>
                    setEditData({ ...editData, positionTitle: e.target.value })
                  }
                  className="border rounded p-2 w-full"
                >
                  <option value="">Select Position</option>
                  <option value="executive">Executive</option>
                  <option value="recruiter">Recruiter</option>
                  <option value="intern">Intern</option>
                  <option value="senior-executive">Senior Executive</option>
                  <option value="team-lead">Team Lead</option>
                  <option value="senior-team-lead">Senior Team Lead</option>
                  <option value="senior-manager">Senior Manager</option>
                  <option value="manager">Manager</option>
                  <option value="assistant-manager">Assistant Manager</option>
                  <option value="payroll-specialist">Payroll Specialist</option>
                </select>
                <select
                  value={editData.department}
                  onChange={(e) =>
                    setEditData({ ...editData, department: e.target.value })
                  }
                  className="border rounded p-2 w-full"
                >
                  <option value="">Select Department</option>
                  <option value="hr">HR</option>
                  <option value="sales">Sales</option>
                  <option value="payroll">Payroll</option>
                  <option value="mis">MIS</option>
                  <option value="it-support">It Support</option>
                  <option value="training-and-development">
                    Training and Development
                  </option>
                  <option value="research-and-development">
                    Research and Development
                  </option>
                  <option value="legal">Legal</option>
                  <option value="administration">Administration</option>
                  <option value="quality-assurance">Quality Assurance</option>
                  <option value="logistics">Logistics</option>
                  <option value="finance">Finance</option>
                </select>
                <select
                  value={editData.applicationStatus}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      applicationStatus: e.target.value,
                    })
                  }
                  className="border rounded p-2 w-full"
                >
                  <option value="">Select Status</option>
                  <option value="applied">Applied</option>
                  <option value="screened">Screened</option>
                  <option value="interviewed">Interviewed</option>
                  <option value="selected">Selected</option>
                  <option value="rejected">Rejected</option>
                  <option value="hired">Hired</option>
                  <option value="draft">Draft</option>
                  <option value="absconded">Absconded</option>
                  <option value="not-joined">Not Joined</option>
                  <option value="joined">Joined</option>
                  <option value="offerd">Offered</option>
                </select>
              </div>

              <div className="mt-6 flex justify-end gap-4">
                <button
                  onClick={() => setIsEditOpen(false)}
                  className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={async () => {
                    try {
                      const res = await fetch(
                        `${apiurl}/api/application/update/${application._id}`,
                        {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({
                            candidateSnapshot: {
                              firstName: editData.firstName,
                              lastName: editData.lastName,
                              email: editData.email,
                              phone: editData.phone,
                              gender: editData.gender,
                              dateOfBirth: editData.dateOfBirth,
                            },
                            positionTitle: editData.positionTitle,
                            department: editData.department,
                            applicationStatus: editData.applicationStatus,
                          }),
                        }
                      );

                      const data = await res.json();
                      if (res.ok) {
                        alert("Updated successfully!");
                        setIsEditOpen(false);
                        // Optional: refresh data or state
                      } else {
                        alert(data.error || "Update failed");
                      }
                    } catch (err) {
                      console.error(err);
                      alert("Server error");
                    }
                  }}
                  className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="p-2 bg-gray-100 min-h-screen">
          {/* <div className="bg-white border rounded-xl p-6 w-full hover:shadow-lg my-2">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-gray-800 flex items-center">
                <span>Application Details</span>
                <button
                  onClick={() => setIsEditOpen(true)}
                  className="flex items-center text-blue-600 hover:text-blue-800 ml-2"
                >
                  <FaEdit className="inline mx-1" />
                </button>
              </h2>

              <Link
                to={`/candidates/${applicationData?.candidate?._id}`}
                type="button"
                class="flex items-center rounded bg-blue-600 px-2 py-1 text-xs font-medium uppercase leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-blue-600 hover:shadow-lg focus:bg-blue-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg"
              >
                View Candidate
                <span class="relative mx-1 inline-block rounded-md bg-red-600 py-1 pr-2 text-center">
                  <span class="ml-2 whitespace-nowrap rounded align-middle font-bold text-white">
                    {applicationData?.applicationCount}
                  </span>
                  <span class="absolute top-0 right-0 left-0 bottom-0 animate-ping bg-red-700"></span>
                </span>
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <p>
                <strong>Application ID:</strong> {application?.id}
              </p>
              <p>
                <strong>Aadhar Number:</strong>{" "}
                {application?.candidateSnapshot?.aadharNumber}
              </p>
              <p>
                <strong>Name:</strong>{" "}
                {application?.candidateSnapshot?.firstName}{" "}
                {application?.candidateSnapshot?.lastName}
              </p>
              <p>
                <strong>Email:</strong> {application?.candidateSnapshot?.email}
              </p>
              <p>
                <strong>Phone:</strong> {application?.candidateSnapshot?.phone}
              </p>
              <p>
                <strong>Position:</strong> {application?.positionTitle}
              </p>
              <p>
                <strong>Department:</strong>{" "}
                {application.createdAt
                  ? new Date(application.createdAt).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "N/A"}
              </p>
              <p>
                <strong>Department:</strong>{" "}
                {application?.appliedPositions?.length}
              </p>
              <p>
                <strong>Department:</strong> {application?.department}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                <span className="text-blue-600">
                  {application?.applicationStatus}
                </span>
              </p>
            </div>

            <div className="mt-6 flex gap-4">
              {application?.documents?.resume?.link && (
                <button
                  onClick={() => openModal(application.documents.resume.link)}
                  className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 shadow"
                >
                  View Resume
                </button>
              )}
              {application?.documents?.aadharCard?.link && (
                <button
                  onClick={() =>
                    openModal(application.documents.aadharCard.link)
                  }
                  className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 shadow"
                >
                  View Aadhar Card
                </button>
              )}
            </div>
          </div> */}

           <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="bg-white border rounded-2xl p-6 w-full shadow-sm hover:shadow-lg transition"
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          Application Details
          <button
            onClick={() => setIsEditOpen(true)}
            className="flex items-center text-blue-600 hover:text-blue-800"
          >
            <FaEdit className="w-4 h-4" />
          </button>
        </h2>

        <Link
          to={`/candidates/${applicationData?.candidate?._id}`}
          className="relative flex items-center rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium uppercase tracking-wide text-white shadow-md transition hover:bg-blue-700"
        >
          View Candidate
          {applicationData?.applicationCount > 0 && (
            <span className="ml-2 relative inline-flex items-center justify-center rounded-full bg-red-600 px-2 py-0.5 text-[10px] font-bold">
              {applicationData?.applicationCount}
              <span className="absolute inset-0 rounded-full bg-red-700 animate-ping opacity-50"></span>
            </span>
          )}
        </Link>
      </div>

      {/* Info Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 text-sm">
        <InfoItem icon={<Hash />} label="Application ID" value={application?.id} />
        <InfoItem icon={<IdCard />} label="Aadhar Number" value={application?.candidateSnapshot?.aadharNumber} />
        <InfoItem icon={<User />} label="Name" value={`${application?.candidateSnapshot?.firstName} ${application?.candidateSnapshot?.lastName}`} />
        <InfoItem icon={<Mail />} label="Email" value={application?.candidateSnapshot?.email} />
        <InfoItem icon={<Phone />} label="Phone" value={application?.candidateSnapshot?.phone} />
        <InfoItem icon={<Briefcase />} label="Position" value={application?.positionTitle} />
        <InfoItem
          icon={<Calendar />}
          label="Applied On"
          value={
            application?.createdAt
              ? new Date(application.createdAt).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "N/A"
          }
        />
        <InfoItem icon={<Building2 />} label="Department" value={application?.department} />
        <InfoItem
          icon={<FileText />}
          label="Status"
          value={
            <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold bg-blue-100 text-blue-700">
              {application?.applicationStatus}
            </span>
          }
        />
        <InfoItem icon={<IdCard />} label="Employee ID" value={application?.employeeId} />
      </div>

      {/* Documents */}
      <div className="mt-6 flex flex-wrap gap-3">
        {application?.documents?.resume?.link && (
          <button
            onClick={() => openModal(application.documents.resume.link)}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-xl hover:bg-green-700 shadow transition"
          >
            <FileText className="w-4 h-4" /> View Resume
          </button>
        )}
        {application?.documents?.aadharCard?.link && (
          <button
            onClick={() => openModal(application.documents.aadharCard.link)}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-xl hover:bg-green-700 shadow transition"
          >
            <IdCard className="w-4 h-4" /> View Aadhar Card
          </button>
        )}
      </div>
    </motion.div>
          <ExperienceCard
            application={application}
            applicationObjId={applicationObjId}
            onStatusChange={fetchApplication}
          />

          <AddRemarkForm
            applicationObjId={applicationObjId}
            userObjId={userData?._id}
            onStatusChange={fetchApplication}
            application={application}
          />

          <div className="bg-white border rounded-xl p-6 w-full hover:shadow-lg my-2">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">
              Reference Details
            </h2>

            {/* Reference Type */}
            <div className="mb-4">
              <p className="text-sm font-medium text-gray-700">
                Reference Type:
              </p>
              <p className="text-lg text-gray-900">
                {application.referenceDetails.referenceType}
              </p>
            </div>

            {/* Employee Information */}
            {application.referenceDetails.referenceType === "employee" && (
              <>
                <div className="mb-4">
                  <p className="text-sm font-medium text-gray-700">
                    Employee Name:
                  </p>
                  <p className="text-lg text-gray-900">
                    {application.referenceDetails.employeeName || "N/A"}
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-sm font-medium text-gray-700">
                    Employee ID:
                  </p>
                  <p className="text-lg text-gray-900">
                    {application.referenceDetails.employeeId || "N/A"}
                  </p>
                </div>
              </>
            )}

            {/* Recruiter Information */}
            {application.referenceDetails.referenceType === "recruiter" && (
              <>
                <div className="mb-4">
                  <p className="text-sm font-medium text-gray-700">
                    Recruiter Name:
                  </p>
                  <p className="text-lg text-gray-900">
                    {application.referenceDetails.recruiterName || "N/A"}
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-sm font-medium text-gray-700">
                    Recruiter ID:
                  </p>
                  <p className="text-lg text-gray-900">
                    {application.referenceDetails.recruiterId || "N/A"}
                  </p>
                </div>
              </>
            )}

            {/* Other Reference */}
            {application.referenceDetails.referenceType === "other" && (
              <div className="mb-4">
                <p className="text-sm font-medium text-gray-700">
                  Other Reference:
                </p>
                <p className="text-lg text-gray-900">
                  {application.referenceDetails.otherReference || "N/A"}
                </p>
              </div>
            )}

            {application.referenceDetails.referenceType === "consultancy" && (
              <div className="mb-4">
                <p className="text-sm font-medium text-gray-700">
                  Consultancy Reference:
                </p>
                <p className="text-lg text-gray-900">
                  {application.referenceDetails.consultancyReference || "N/A"}
                </p>
              </div>
            )}

            {/* Walk-in Reference */}
            {application.referenceDetails.referenceType === "walkin" && (
              <div className="mb-4">
                <p className="text-sm font-medium text-gray-700">
                  Walk-in Reference:
                </p>
                <p className="text-lg text-gray-900">
                  {application.referenceDetails.walkInReference || "N/A"}
                </p>
              </div>
            )}
          </div>

          <ReferenceDetailsForm
            applicationObjId={applicationObjId}
            onStatusChange={fetchApplication}
          />

          {/* Screener Card */}
          <ScreenerReview
            userData={userData}
            application={application}
            onStatusChange={fetchApplication}
          />

          {/* Trainer Card */}
          <TrainerCard
            userData={userData}
            application={application}
            onStatusChange={fetchApplication}
          />
          <ManagerAssignCard
            application={application}
            applicationObjId={application._id}
            apiurl={apiurl}
            onStatusChange={fetchApplication}
            // fetchAttendance={fetchAttendance}
          />
          <EmployeeIdAssignCard
            applicationObjId={application._id}
            application={application}
            onStatusChange={fetchApplication}
            // fetchAttendance={fetchAttendance}
          />
          {application?._id && (
            <CandidateJoinCard
              userData={userData}
              application={application}
              onStatusChange={fetchApplication}
            />
          )}
        </div>

        {showModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-80 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-7xl w-full">
              <h2 className="text-xl font-semibold mb-4">Document Preview</h2>

              {documentLink.endsWith(".pdf") ? (
                <iframe
                  src={documentLink}
                  className="w-full h-[500px] rounded-lg"
                  title="PDF Preview"
                />
              ) : documentLink.endsWith(".docx") ||
                documentLink.endsWith(".xlsx") ? (
                <iframe
                  src={`https://docs.google.com/gview?url=${documentLink}&embedded=true`}
                  className="w-full h-[500px] rounded-lg"
                  title="Google Docs Viewer"
                />
              ) : (
                <img
                  src={documentLink}
                  alt="Document Preview"
                  className="w-full max-h-[500px] object-contain rounded-lg"
                />
              )}

              <div className="mt-6 flex justify-end gap-4">
                <a
                  href={documentLink}
                  target="_blank"
                  download
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 shadow"
                >
                  Download
                </a>
                <button
                  onClick={closeModal}
                  className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 shadow"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        <CreateEmployeeCard
          applicationObjId={applicationObjId}
          application={application}
          userData={userData}
          navigate={navigate}
        />
        {/* <div className="my-5 flex justify-end items-end">
          <button
            onClick={() => handleDelete(applicationObjId)}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
          >
            Delete
          </button>
        </div> */}

        <div className="my-5 flex justify-end items-end">
          <button
            onClick={() => sendCanceled(applicationObjId)}
            className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition"
          >
            Send Canceled Mail
          </button>
        </div>
      </Container>
    </Layout>
  );
};

export default ManageApplication;

export const ScreenerReview = ({ application, userData, onStatusChange }) => {
  const { applicationObjId } = useParams();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [screener, setScreener] = useState(null);
  const [status, setStatus] = useState(true);
  const [showReassignForm, setShowReassignForm] = useState(false);

  console.log("application 157 ", application);

  const handleDecision = async (status) => {
    let payload;

    if (application?.screeningDetails?.screenerId) {
      payload = {
        applicationIdObj: application?._id,
        status: status,
        feedback: feedback,
      };
    } else {
      payload = {
        applicationIdObj: application?._id,
        screenerObjId: userData?._id,
        screenerId: userData?.id,
        screenerName: `${userData?.firstName} ${userData?.lastName}`,
        status: status,
        feedback: feedback,
      };
    }

    try {
      await axios.post(
        `${apiurl}/api/application/assign/screener/status`,
        payload
      );

      toast.success("Status updated successfully!", {
        position: "top-right",
        autoClose: 3000,
      });

      // setTimeout(() => {
      //   window.location.reload(); // Refresh page after 3 seconds
      // }, 3000);
      onStatusChange && onStatusChange();
    } catch (error) {
      toast.error("Error updating status. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
      console.error("Error updating status:", error);
    }
  };

  console.log("application 371", application);

  // if (loading) return <p>Loading screener details...</p>;

  return (
    <div className="bg-white border rounded-xl p-6 w-full hover:shadow-lg my-2">
      <h3 className="text-lg font-semibold">Screener</h3>
      {application?.screeningDetails?.status ? (
        <>
          <div
            className={`border p-4 rounded-lg my-4 ${
              application?.screeningDetails?.status === "pass"
                ? "border-green-500 text-green-800 bg-green-50"
                : application?.screeningDetails?.status === "fail"
                ? "border-red-500 text-red-800 bg-red-50"
                : "border-gray-500 text-gray-800 bg-gray-100"
            }`}
          >
            <p>
              <strong>Name:</strong>{" "}
              {application?.screeningDetails?.screenerName}
            </p>
            <p>
              <strong>ID:</strong> {application?.screeningDetails?.screenerId}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              {application?.screeningDetails?.status === "pass"
                ? "Approved"
                : application?.screeningDetails?.status === "fail"
                ? "Rejected"
                : "Pending"}
            </p>
            <p>
              <strong>Feedback:</strong>{" "}
              {application?.screeningDetails?.feedback}
            </p>
            <p>
              <strong>Date:</strong> {application?.screeningDetails?.date}
            </p>
            {!showReassignForm && (
              <button
                className="mt-4 bg-yellow-500 text-white px-4 py-2 rounded"
                onClick={() => setShowReassignForm(true)}
              >
                Reassign & Update
              </button>
            )}
          </div>

          {showReassignForm && (
            <div className="border p-4 rounded-lg bg-yellow-50 mt-4">
              <p className="mb-2 font-semibold text-gray-700">
                Update Feedback & Status:
              </p>
              <input
                type="text"
                placeholder="Feedback"
                className="border p-2 my-2 w-full"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
              <div className="flex gap-2">
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded"
                  onClick={() => handleDecision("pass")}
                >
                  Approve
                </button>
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded"
                  onClick={() => handleDecision("fail")}
                >
                  Reject
                </button>
                <button
                  className="bg-yellow-600 text-white px-4 py-2 rounded"
                  onClick={() => handleDecision("hold")}
                >
                  Hold
                </button>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {application?.screeningDetails?.screenerId ? (
            <>
              <div className="border p-4 rounded-lg">
                <div className="border p-4 border-green-500 rounded-lg text-green-800 bg-green-50 my-4">
                  <p>
                    <strong>Name:</strong>{" "}
                    {application?.screeningDetails?.screenerName}
                  </p>
                  <p>
                    <strong>ID:</strong>{" "}
                    {application?.screeningDetails?.screenerId}
                  </p>
                </div>
                <input
                  type="text"
                  placeholder="Feedback"
                  className="border p-2 my-4 w-full"
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded"
                  onClick={() => handleDecision("pass")}
                >
                  Approve
                </button>
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded ml-2"
                  onClick={() => handleDecision("fail")}
                >
                  Reject
                </button>
                <button
                  className="bg-yellow-500 text-white px-4 py-2 rounded ml-2"
                  onClick={() => handleDecision("hold")}
                >
                  Hold
                </button>
              </div>

              {/* <div>
              ddd
            </div> */}
            </>
          ) : (
            <div>
              <div className="border p-4 rounded-lg">
                <div className="border p-4 border-red-500 rounded-lg text-red-800 bg-red-50 my-4 flex justify-between items-center">
                  <p>Screener Not Assigned yet</p>
                  {/* <button
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                    onClick={() => handleAssign("screener")}
                  >
                    Assign
                  </button> */}
                </div>

                <div className="border p-4 border-green-500 rounded-lg text-green-800 bg-green-50 my-4">
                  Proceed as
                  <p>
                    <strong>Name:</strong>
                    {userData?.firstName} {userData?.lastName}
                  </p>
                  <p>
                    <strong>ID:</strong> {userData?.screenerId}
                  </p>
                </div>
                <input
                  type="text"
                  placeholder="Feedback"
                  className="border p-2 my-4 w-full"
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded"
                  onClick={() => handleDecision("pass")}
                >
                  Approve
                </button>
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded ml-2"
                  onClick={() => handleDecision("fail")}
                >
                  Reject
                </button>
                <button
                  className="bg-yellow-500 text-white px-4 py-2 rounded ml-2"
                  onClick={() => handleDecision("hold")}
                >
                  Hold
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

// export const CandidateJoinCard = ({
//   userData,
//   application,
//   onStatusChange,
// }) => {
//   const [experienceLevel, setExperienceLevel] = useState("");
//   const [salary, setSalary] = useState("");
//   const [joiningDate, setJoiningDate] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSendJoinEmail = async () => {
//     if (!experienceLevel || !salary || !joiningDate) {
//       return toast.error("Please fill all fields");
//     }
//     if (!application.trainingDetails.trainerId) {
//       return toast.error("Please assigne trainer first");
//     }

//     let officeAddress = "";
//     if (application.trainingDetails.trainerId !== "1000006") {
//       officeAddress =
//         "Suwasthi Intense Healthcare Pvt. Ltd. 5th Floor, GMIT Park, Sector-142 Noida 201305";
//     } else if (application.trainingDetails.trainerId === "1000007") {
//       officeAddress =
//         "Suwasthi Intense Healthcare Pvt. Ltd. 5th Floor, ALT F, Sector-142, Noida, UP 201305";
//     }

//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${apiurl}/api/application/send-joining-mail`,
//         {
//           applicationObjId: application._id,
//           offeredCTC: salary,
//           joiningDate,
//           officeAddress,
//         }
//       );

//       if (response.data.success) {
//         toast.success("Join email sent successfully!");
//         // window.location.reload();
//         onStatusChange && onStatusChange();
//       } else {
//         toast.error("Failed to send join email.");
//       }
//     } catch (error) {
//       console.error("Error sending join email:", error);
//       toast.error("Failed to send join email.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {application.applicationStatus === "offered" ||
//       application.applicationStatus === "hired" ? (
//         <div className="bg-yellow-100 border border-yellow-400  text-yellow-800 rounded-xl p-6 w-full hover:shadow-lg my-2">
//           <p>
//             <strong>Candidate offered.</strong>
//           </p>
//           <p>CTC: ₹ {application?.offerDetails?.offeredCTC} LPA</p>
//           <p>
//             Joining Date:{" "}
//             {new Date(
//               application?.offerDetails?.joiningDate
//             ).toLocaleDateString("en-GB", {
//               day: "2-digit",
//               month: "short",
//               year: "numeric",
//             })}
//           </p>
//         </div>
//       ) : (
//         <div className="bg-white shadow-md rounded-lg p-6 mt-4 w-full">
//           <h3 className="text-lg font-semibold mb-4">Send Join Email</h3>

//           {/* Experience Level Selection */}
//           <label className="block text-sm font-medium">Experience Level</label>
//           <select
//             className="border p-2 w-full mt-2 rounded"
//             value={experienceLevel}
//             onChange={(e) => setExperienceLevel(e.target.value)}
//           >
//             <option value="">Select Experience</option>
//             <option value="Fresher">Fresher</option>
//             <option value="Experienced">Experienced</option>
//           </select>

//           {/* Salary Input */}
//           <label className="block text-sm font-medium mt-3">CTC (LPA)</label>
//           <input
//             type="number"
//             placeholder="Enter offered CTC"
//             className="border p-2 w-full mt-2 rounded"
//             value={salary}
//             onChange={(e) => setSalary(e.target.value)}
//           />

//           {/* Joining Date Input */}
//           <label className="block text-sm font-medium mt-3">Joining Date</label>
//           <input
//             type="date"
//             className="border p-2 w-full mt-2 rounded"
//             value={joiningDate}
//             onChange={(e) => setJoiningDate(e.target.value)}
//           />

//           {/* Send Email Button */}
//           <button
//             className={`mt-4 px-4 py-2 rounded text-white w-fit ${
//               loading
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-blue-500 hover:bg-blue-600"
//             }`}
//             onClick={handleSendJoinEmail}
//             disabled={loading}
//           >
//             {loading ? "Sending..." : "Send Join Email"}
//           </button>
//         </div>
//       )}
//     </>
//   );
// };

export const CandidateJoinCard = ({
  userData,
  application,
  onStatusChange,
}) => {
  const [experienceLevel, setExperienceLevel] = useState("");
  const [salary, setSalary] = useState("");
  const [monthlySalary, setMonthlySalary] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const getOfficeAddress = () => {
    if (application.trainingDetails.trainerId !== "1000006") {
      return "Suwasthi Intense Healthcare Pvt. Ltd. 5th Floor, GMIT Park, Sector-142 Noida 201305";
    } else if (application.trainingDetails.trainerId === "1000007") {
      return "Suwasthi Intense Healthcare Pvt. Ltd. 5th Floor, ALT F, Sector-142, Noida, UP 201305";
    }
    return "";
  };

  // const sendJoinEmail = async (customData) => {
  //   const { exp, ctc, date } = customData;

  //   if (!exp || !ctc || !date) {
  //     return toast.error("Please fill all fields");
  //   }
  //   if (!application.trainingDetails.trainerId) {
  //     return toast.error("Please assign trainer first");
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await axios.post(`${apiurl}/api/application/send-joining-mail`, {
  //       applicationObjId: application._id,
  //       offeredCTC: ctc,
  //       monthlySalary,
  //       joiningDate: date,
  //       officeAddress: getOfficeAddress(),
  //     });

  //     if (response.data.success) {
  //       toast.success("Join email sent successfully!");
  //       onStatusChange && onStatusChange();
  //       setEditMode(false);
  //     } else {
  //       toast.error("Failed to send join email.");
  //     }
  //   } catch (error) {
  //     console.error("Error sending join email:", error);
  //     toast.error("Failed to send join email.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const sendJoinEmail = async (customData) => {
    const { exp, ctc, date, monthlySalary } = customData;

    if (!exp || !date || (!ctc && !monthlySalary)) {
      return toast.error("Please fill all fields");
    }
    if (!application.trainingDetails.trainerId) {
      return toast.error("Please assign trainer first");
    }

    // if ctc not valid, calculate from monthlySalary
    const offeredCTC =
      ctc && !isNaN(ctc) && Number(ctc) > 0
        ? Number(ctc)
        : Number(monthlySalary) * 12;

    setLoading(true);
    try {
      const response = await axios.post(
        `${apiurl}/api/application/send-joining-mail`,
        {
          applicationObjId: application._id,
          offeredCTC,
          monthlySalary,
          joiningDate: date,
          officeAddress: getOfficeAddress(),
        }
      );

      if (response.data.success) {
        toast.success("Join email sent successfully!");
        onStatusChange && onStatusChange();
        setEditMode(false);
      } else {
        toast.error("Failed to send join email.");
      }
    } catch (error) {
      console.error("Error sending join email:", error);
      toast.error("Failed to send join email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6 mt-4 w-full">
      {application.applicationStatus === "offered" ||
      application.applicationStatus === "hired" ||
      application.applicationStatus === "joined" ||
      application.applicationStatus === "absconded" ||
      application.applicationStatus === "training" ||
      application.applicationStatus === "onboarding" ? (
        <>
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 rounded-xl p-4 mb-4">
            <p>
              <strong>Candidate offered.</strong>
            </p>
            <p>
              Experience: {application?.offerDetails?.experienceLevel || "N/A"}
            </p>
            <p>CTC: ₹ {application?.offerDetails?.offeredCTC} LPA</p>
            <p>Monthly Salary: ₹ {application?.offerDetails?.monthlySalary}</p>
            <p>
              Joining Date:{" "}
              {new Date(
                application?.offerDetails?.joiningDate
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </p>
          </div>

          {!editMode ? (
            <div className="flex gap-3">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                onClick={() => {
                  setExperienceLevel(
                    application?.offerDetails?.experienceLevel || ""
                  );
                  setSalary(application?.offerDetails?.offeredCTC || "");
                  setJoiningDate(
                    application?.offerDetails?.joiningDate
                      ? new Date(application.offerDetails.joiningDate)
                          .toISOString()
                          .split("T")[0]
                      : ""
                  );
                  setEditMode(true);
                }}
              >
                Revise Offer
              </button>

              {/* <button
                className={`px-4 py-2 rounded text-white ${
                  loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"
                }`}
                onClick={() =>
                  sendJoinEmail({
                    exp: application?.offerDetails?.experienceLevel,
                    ctc: application?.offerDetails?.offeredCTC,
                    date: application?.offerDetails?.joiningDate,
                  })
                }
                disabled={loading}
              >
                {loading ? "Sending..." : "Resend Email"}
              </button> */}
            </div>
          ) : (
            <>
              {/* Editable fields */}
              <label className="block text-sm font-medium mt-3">
                Experience Level
              </label>
              <select
                className="border p-2 w-full mt-2 rounded"
                value={experienceLevel}
                onChange={(e) => setExperienceLevel(e.target.value)}
              >
                <option value="">Select Experience</option>
                <option value="Fresher">Fresher</option>
                <option value="Experienced">Experienced</option>
              </select>

              <label className="block text-sm font-medium mt-3">
                CTC (LPA)
              </label>
              <input
                type="number"
                placeholder="Enter offered CTC"
                className="border p-2 w-full mt-2 rounded"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
              />
              <label className="block text-sm font-medium mt-3">
                Monthly Salary
              </label>
              <input
                type="number"
                placeholder="Enter monthly salary"
                className="border p-2 w-full mt-2 rounded"
                value={monthlySalary}
                onChange={(e) => setMonthlySalary(e.target.value)}
              />
              <label className="block text-sm font-medium mt-3">
                CTC (LPA)
              </label>
              <input
                type="number"
                placeholder="Enter offered CTC"
                className="border p-2 w-full mt-2 rounded"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
              />

              <label className="block text-sm font-medium mt-3">
                Joining Date
              </label>
              <input
                type="date"
                className="border p-2 w-full mt-2 rounded"
                value={joiningDate}
                onChange={(e) => setJoiningDate(e.target.value)}
              />

              <div className="flex gap-3 mt-4">
                <button
                  className={`px-4 py-2 rounded text-white ${
                    loading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }`}
                  onClick={() =>
                    sendJoinEmail({
                      exp: experienceLevel,
                      ctc: salary,
                      monthlySalary,
                      date: joiningDate,
                    })
                  }
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Update & Send"}
                </button>
                <button
                  className="px-4 py-2 rounded border border-gray-400 hover:bg-gray-100"
                  onClick={() => setEditMode(false)}
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <h3 className="text-lg font-semibold mb-4">Send Join Email</h3>

          <label className="block text-sm font-medium">Experience Level</label>
          <select
            className="border p-2 w-full mt-2 rounded"
            value={experienceLevel}
            onChange={(e) => setExperienceLevel(e.target.value)}
          >
            <option value="">Select Experience</option>
            <option value="Fresher">Fresher</option>
            <option value="Experienced">Experienced</option>
          </select>

          <label className="block text-sm font-medium mt-3">CTC (LPA)</label>
          <input
            type="number"
            placeholder="Enter offered CTC"
            className="border p-2 w-full mt-2 rounded"
            value={salary}
            onChange={(e) => setSalary(e.target.value)}
          />
          <label className="block text-sm font-medium mt-3">
            Monthly Salary
          </label>
          <input
            type="number"
            placeholder="Enter monthly salary"
            className="border p-2 w-full mt-2 rounded"
            value={monthlySalary}
            onChange={(e) => setMonthlySalary(e.target.value)}
          />

          <label className="block text-sm font-medium mt-3">Joining Date</label>
          <input
            type="date"
            className="border p-2 w-full mt-2 rounded"
            value={joiningDate}
            onChange={(e) => setJoiningDate(e.target.value)}
          />

          <button
            className={`mt-4 px-4 py-2 rounded text-white w-fit ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
            onClick={() =>
              sendJoinEmail({
                exp: experienceLevel,
                ctc: salary,
                monthlySalary,
                date: joiningDate,
              })
            }
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Join Email"}
          </button>
        </>
      )}
    </div>
  );
};



export const TrainerCard = ({ application, userData, onStatusChange }) => {
  const { applicationObjId } = useParams();
  const [trainers, setTrainers] = useState([]);
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [trainerFeedback, setTrainerFeedback] = useState("");
  const [mockFeedback, setMockFeedback] = useState("");
  const [mockStatus, setMockStatus] = useState("pass");
  const [ojtStatus, setOjtStatus] = useState("");
  const [ojtFeedback, setOjtFeedback] = useState("");
  const [ojtRemarks, setOjtRemarks] = useState("");
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [completedData, setCompletedData] = useState(null);
  const [reassignMode, setReassignMode] = useState(false);

  const trainingDetails = application?.trainingDetails;

  useEffect(() => {
    fetchTrainers();
    fetchAttendance();
    if (trainingDetails?.ojt) {
      setOjtStatus(trainingDetails.ojt.status || "");
      setOjtFeedback(trainingDetails.ojt.feedback || "");
      setOjtRemarks(trainingDetails.ojt.remarks || "");
    }
  }, []);

  const fetchTrainers = async () => {
    try {
      const response = await axios.post(`${apiurl}/api/user/getbyrole`, {
        role: "trainer",
        status: "active",
      });
      if (response.data.success) setTrainers(response.data.users);
    } catch (err) {
      console.error("Error fetching trainers:", err);
    }
  };

  const fetchAttendance = async () => {
    try {
      const res = await axios.get(
        `${apiurl}/api/application/training/attendance/${applicationObjId}`
      );
      const tDetails = res?.data?.trainingDetails;
      setAttendance(tDetails?.trainingAttendance || []);

      if (tDetails?.status === "completed") {
        setCompletedData({
          feedback: tDetails.feedback,
          name: tDetails.trainerName,
          id: tDetails.trainerId,
          date: tDetails.endDate
            ? new Date(tDetails.endDate).toLocaleString()
            : null,
          mockcall: tDetails.mockcall || [],
          ojt: tDetails.ojt || {},
        });
      }
    } catch (err) {
      console.error("Error fetching attendance:", err);
    } finally {
      setLoading(false);
    }
  };

  // Assign or Reassign Trainer
  const handleAssignTrainer = async () => {
    if (!selectedTrainer) return toast.error("Select a trainer");
    try {
      await axios.post(`${apiurl}/api/application/assign/trainer`, {
        trainerObjId: selectedTrainer,
        applicationObjIds: [applicationObjId],
      });
      toast.success("Trainer assigned successfully");
      onStatusChange?.();
      fetchAttendance();
      setReassignMode(false);
    } catch (err) {
      console.error("Error assigning trainer:", err);
    }
  };

  // Mark Training Complete
  const handleMarkCompleted = async () => {
    if (!trainerFeedback) return toast.error("Please provide feedback");
    try {
      await axios.post(`${apiurl}/api/application/training/mark-complete`, {
        applicationIdObjs: [applicationObjId],
        feedback: trainerFeedback,
        updatedBy: {
          userObjId: userData?._id,
          userId: userData?.employeeId,
          userName: `${userData?.firstName} ${userData?.lastName}`,
        },
      });
      toast.success("Training marked as completed");
      onStatusChange?.();
      fetchAttendance();
    } catch (err) {
      console.error("Error marking training complete:", err);
    }
  };

  // Submit Mock Call
  const handleMockCall = async () => {
    if (!mockFeedback) return toast.error("Please provide mock feedback");
    try {
      await axios.post(`${apiurl}/api/application/training/mock-call`, {
        applicationIdObj: applicationObjId,
        feedback: mockFeedback,
        status: mockStatus,
        round: trainingDetails.mockcall?.length + 1,
        actionBy: {
          userObjId: userData?._id,
          userId: userData?.employeeId,
          userName: `${userData?.firstName} ${userData?.lastName}`,
        },
        updatedBy: {
          userObjId: userData?._id,
          userId: userData?.employeeId,
          userName: `${userData?.firstName} ${userData?.lastName}`,
        },
      });
      toast.success("Mock call submitted");
      onStatusChange?.();
      fetchAttendance();
      setMockFeedback("");
    } catch (err) {
      console.error("Error submitting mock call:", err);
    }
  };

  // Update OJT
  const handleOjtUpdate = async () => {
    if (!ojtStatus) return toast.error("Select OJT status");
    try {
      await axios.post(`${apiurl}/api/application/training/ojt-update`, {
        applicationIdObj: applicationObjId,
        status: ojtStatus,
        remarks: ojtRemarks,
        feedback: ojtFeedback,
        actionBy: {
          userObjId: userData?._id,
          userId: userData?.employeeId,
          userName: `${userData?.firstName} ${userData?.lastName}`,
        },
      });
      toast.success("OJT updated successfully");
      onStatusChange?.();
      fetchAttendance();
    } catch (err) {
      console.error("Error updating OJT:", err);
    }
  };

  // Mark Attendance
  const markAttendance = async (day) => {
    try {
      await axios.post(`${apiurl}/api/application/training/mark-attendance`, {
        applicationObjId,
        day,
        attended: true,
        actionBy: {
          userObjId: userData?._id,
          userId: userData?.employeeId,
          userName: `${userData?.firstName} ${userData?.lastName}`,
        },
      });
      toast.success("Attendance marked");
      fetchAttendance();
    } catch (err) {
      console.error("Error marking attendance:", err);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <motion.div
      className="bg-white shadow-md rounded-lg p-6 mt-4"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <h3 className="text-lg font-semibold mb-4">Trainer & Training Details</h3>

      {/* Trainer Assign / Reassign */}
      <div className="mb-4 border p-4 rounded">
        <p>
          <strong>Trainer:</strong>{" "}
          {trainingDetails?.trainerName || "Not Assigned"}
        </p>
        {!completedData && (
          <div className="flex gap-2 mt-2 items-center">
            <select
              className="border p-2 flex-1"
              value={selectedTrainer || ""}
              onChange={(e) => setSelectedTrainer(e.target.value)}
            >
              <option value="">Select Trainer</option>
              {trainers.map((t) => (
                <option key={t._id} value={t._id}>
                  {t.firstName} {t.lastName}
                </option>
              ))}
            </select>
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded"
              onClick={handleAssignTrainer}
            >
              {trainingDetails?.trainerName ? "Reassign" : "Assign"}
            </button>
          </div>
        )}
      </div>

      {/* Training Completion */}
      {!completedData && trainingDetails?.trainerId && (
        <div className="mb-4 border p-4 rounded">
          <h4 className="font-semibold mb-2">Training Completion</h4>
          <textarea
            className="border w-full p-2 mb-2"
            placeholder="Trainer Feedback"
            value={trainerFeedback}
            onChange={(e) => setTrainerFeedback(e.target.value)}
          />
          <button
            className="bg-green-600 text-white px-4 py-2 rounded"
            onClick={handleMarkCompleted}
          >
            Mark Complete
          </button>
        </div>
      )}

      {/* Mock Call Section */}
      <div className="mb-4 border p-4 rounded">
        <h4 className="font-semibold mb-2">Mock Calls</h4>
        <ul className="list-disc ml-6 mb-2">
          {(application?.trainingDetails?.mockcall || []).map((mock) => (
            <li key={mock._id}>
              {new Date(mock.date).toLocaleString()} —{" "}
              <strong>{mock.status.toUpperCase()}</strong>: {mock.feedback}
            </li>
          ))}
        </ul>
        {!completedData && (
          <>
            <textarea
              className="border w-full p-2 mb-2"
              placeholder="Mock Feedback"
              value={mockFeedback}
              onChange={(e) => setMockFeedback(e.target.value)}
            />
            <select
              className="border w-full p-2 mb-2"
              value={mockStatus}
              onChange={(e) => setMockStatus(e.target.value)}
            >
              <option value="pass">Pass</option>
              <option value="fail">Fail</option>
              <option value="hold">Hold</option>
              <option value="certified">Certified</option>
              <option value="not-certified">Not-Certified</option>
            </select>
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded"
              onClick={handleMockCall}
            >
              Submit Mock
            </button>
          </>
        )}
      </div>

      {/* OJT Section */}
      <div className="mb-4 border p-4 rounded">
        <h4 className="font-semibold mb-2">OJT Details</h4>
        <select
          className="border w-full p-2 mb-2"
          value={ojtStatus}
          onChange={(e) => setOjtStatus(e.target.value)}
        >
          <option value="">Select Status</option>
          <option value="pending">Pending</option>
          <option value="in-progress">In Progress</option>
          <option value="completed">Completed</option>
                        <option value="certified">Certified</option>
              <option value="not-certified">Not-Certified</option>
        </select>
        <textarea
          className="border w-full p-2 mb-2"
          placeholder="OJT Feedback"
          value={ojtFeedback}
          onChange={(e) => setOjtFeedback(e.target.value)}
        />
        <textarea
          className="border w-full p-2 mb-2"
          placeholder="OJT Remarks"
          value={ojtRemarks}
          onChange={(e) => setOjtRemarks(e.target.value)}
        />
        <button
          className="bg-purple-500 text-white px-4 py-2 rounded"
          onClick={handleOjtUpdate}
        >
          Update OJT
        </button>
      </div>

      {/* Attendance */}
      <div className="border p-4 rounded">
        <h4 className="font-semibold mb-2">Attendance</h4>
        <div className="grid grid-cols-5 gap-2">
          {[1, 2, 3, 4, 5].map((day, idx) => {
            const status = attendance[idx]?.attended;
            return (
              <button
                key={idx}
                className={`px-3 py-2 rounded text-white ${
                  status === true
                    ? "bg-green-500"
                    : status === false
                    ? "bg-red-500"
                    : "bg-gray-500"
                }`}
                onClick={() => markAttendance(day)}
              >
                Day {day} – {status === true ? "Present" : "Mark"}
              </button>
            );
          })}
        </div>
      </div>

      {/* Completed Summary */}
      {completedData && (
        <div className="mt-4 p-4 border rounded bg-green-50">
          <h4 className="font-semibold mb-2">Training Completed</h4>
          <p>
            <strong>Feedback:</strong> {completedData.feedback}
          </p>
          <p>
            <strong>Date:</strong> {completedData.date}
          </p>
          {completedData.mockcall?.length > 0 && (
            <>
              <h5 className="font-semibold mt-2">Mock Calls</h5>
              <ul className="list-disc ml-6">
                {completedData.mockcall.map((m) => (
                  <li key={m._id}>
                    {new Date(m.date).toLocaleString()} —{" "}
                    <strong>{m.status.toUpperCase()}</strong>: {m.feedback}
                  </li>
                ))}
              </ul>
            </>
          )}
          {completedData.ojt?.status && (
            <>
              <h5 className="font-semibold mt-2">OJT</h5>
              <p>
                <strong>Status:</strong> {completedData.ojt.status}
              </p>
              <p>
                <strong>Feedback:</strong> {completedData.ojt.feedback}
              </p>
              <p>
                <strong>Remarks:</strong> {completedData.ojt.remarks}
              </p>
            </>
          )}
        </div>
      )}
    </motion.div>
  );
};


// export const TrainerCard = ({ application, userData, onStatusChange }) => {
//   const { applicationObjId } = useParams();
//   const [trainers, setTrainers] = useState([]);
//   const [selectedTrainer, setSelectedTrainer] = useState(null);
//   const [feedback, setFeedback] = useState("");
//   const [mockFeedback, setMockFeedback] = useState("");
//   const [mockStatus, setMockStatus] = useState("pass");
//   const [attendance, setAttendance] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [completedData, setCompletedData] = useState(null);
//   const [reassignMode, setReassignMode] = useState(false);
//   const [manager, setManager] = useState("");
//   const [employeeId, setEmployeeId] = useState("");
//   const [showReassign, setShowReassign] = useState(false);
//   const [showReassignId, setShowReassignId] = useState(false);

//   const trainingDetails = application?.trainingDetails;

//   useEffect(() => {
//     fetchTrainers();
//     fetchAttendance();
//   }, []);

//   const fetchTrainers = async () => {
//     try {
//       const response = await axios.post(`${apiurl}/api/user/getbyrole`, {
//         role: "trainer",
//         status: "active",
//       });
//       if (response.data.success) setTrainers(response.data.users);
//     } catch (err) {
//       console.error("Error fetching trainers:", err);
//     }
//   };

//   const fetchAttendance = async () => {
//     try {
//       const res = await axios.get(
//         `${apiurl}/api/application/training/attendance/${applicationObjId}`
//       );
//       setAttendance(res?.data?.trainingDetails?.trainingAttendance || []);
//       const tDetails = res?.data?.trainingDetails;
//       if (tDetails?.status === "completed") {
//         setCompletedData({
//           feedback: tDetails.feedback,
//           name: tDetails.trainerName,
//           id: tDetails.trainerId,
//           date: new Date(tDetails.endDate).toLocaleString(),
//           mockcall: tDetails.mockcall || [],
//         });
//       }
//     } catch (err) {
//       console.error("Error fetching attendance:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAssignTrainer = async () => {
//     if (!selectedTrainer) return;
//     try {
//       await axios.post(`${apiurl}/api/application/assign/trainer`, {
//         trainerObjId: selectedTrainer,
//         applicationObjIds: [applicationObjId],
//       });
//       toast.success("Trainer assigned successfully");
//       onStatusChange && onStatusChange();
//       fetchAttendance();
//     } catch (err) {
//       console.error("Error assigning trainer:", err);
//     }
//   };
//   const handleAssignManager = async () => {
//     let selectedApplications = [`${applicationObjId}`];

//     try {
//       await axios.post(
//         `${apiurl}/api/application/add-manager`,
//         {
//           applicationObjIds: selectedApplications,
//           reportingManagerName: manager,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       toast.success("manager assigned successfully");
//       onStatusChange && onStatusChange();
//       fetchAttendance();
//     } catch (err) {
//       console.error("Error assigning manager:", err);
//       alert("Failed to assign manager.");
//     }
//   };

//   const handleMarkCompleted = async () => {
//     if (!feedback) return toast.error("Please provide feedback");
//     try {
//       await axios.post(`${apiurl}/api/application/training/mark-complete`, {
//         applicationIdObj: applicationObjId,
//         feedback,
//       });
//       toast.success("Training marked as completed");
//       onStatusChange && onStatusChange();
//       fetchAttendance();
//     } catch (err) {
//       console.error("Error marking training complete:", err);
//     }
//   };

//   const handleMockCall = async () => {
//     if (!mockFeedback) return toast.error("Please provide feedback");
//     try {
//       await axios.post(`${apiurl}/api/application/training/mock-call`, {
//         applicationIdObj: applicationObjId,
//         feedback: mockFeedback,
//         status: mockStatus,
//       });
//       toast.success("Mock call feedback submitted");
//       onStatusChange && onStatusChange();
//       fetchAttendance();
//     } catch (err) {
//       console.error("Error submitting mock call:", err);
//     }
//   };

//   const markAttendance = async (day) => {
//     try {
//       await axios.post(`${apiurl}/api/application/training/mark-attendance`, {
//         applicationObjId,
//         day,
//         attended: true,
//       });
//       toast.success("Attendance marked");
//       fetchAttendance();
//     } catch (err) {
//       console.error("Error marking attendance:", err);
//     }
//   };

//   console.log("completedData", completedData);

//   return (
//     <motion.div
//       className="bg-white shadow-md rounded-lg p-6 mt-4"
//       initial={{ opacity: 0, y: 10 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3 }}
//     >
//       <h3 className="text-lg font-semibold">Trainer</h3>

//       {trainingDetails?.trainerId ? (
//         <div>
//           <p>
//             <strong>Trainer:</strong> {trainingDetails.trainerName} (
//             {trainingDetails.trainerId})
//           </p>
//           <div>
//             {!completedData && !reassignMode && (
//               <button
//                 className="text-blue-500 hover:text-blue-700 transition duration-300"
//                 onClick={() => setReassignMode(true)}
//               >
//                 Reassign Trainer
//               </button>
//             )}
//           </div>

//           {completedData ? (
//             <div className="mt-2 p-2 border rounded bg-green-50">
//               <p>
//                 <strong>Status:</strong> Completed
//               </p>
//               <p>
//                 <strong>Feedback:</strong> {completedData.feedback}
//               </p>
//               <p>
//                 <strong>Completed On:</strong> {completedData.date}
//               </p>
//             </div>
//           ) : (
//             <>
//               <input
//                 type="text"
//                 placeholder="Trainer Feedback"
//                 className="border p-2 w-full mt-2"
//                 value={feedback}
//                 onChange={(e) => setFeedback(e.target.value)}
//               />
//               <button
//                 className="bg-green-600 text-white px-4 py-2 rounded mt-2"
//                 onClick={handleMarkCompleted}
//               >
//                 Mark Training Complete
//               </button>
//             </>
//           )}

//           {/* Reassign Trainer option */}
//           {!completedData && reassignMode && (
//             <div className="mt-2">
//               <select
//                 className="border p-2 w-full"
//                 value={selectedTrainer || ""}
//                 onChange={(e) => setSelectedTrainer(e.target.value)}
//               >
//                 <option value="">Select Trainer</option>
//                 {trainers.map((trainer) => (
//                   <option key={trainer._id} value={trainer._id}>
//                     {trainer.firstName} {trainer.lastName}
//                   </option>
//                 ))}
//               </select>
//               <button
//                 className="bg-yellow-500 text-white px-4 py-2 rounded mt-2"
//                 onClick={handleAssignTrainer}
//               >
//                 Reassign Trainer
//               </button>
//             </div>
//           )}

//           {/* Mock call feedback */}
//           <div className="mt-4">
//             <h4 className="text-md font-semibold">Mock Call Feedback</h4>
//             {!completedData && (
//               <>
//                 {application?.trainingDetails?.mockcall?.length > 0 && (
//                   <ul className="list-disc ml-6 mt-2">
//                     {application?.trainingDetails?.mockcall.map((mock, i) => (
//                       <li key={mock._id}>
//                         {new Date(mock.date).toLocaleString()} —{" "}
//                         <strong>{mock.status.toUpperCase()}</strong>:{" "}
//                         {mock.feedback}
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </>
//             )}
//             {completedData?.mockcall?.length > 0 && (
//               <ul className="list-disc ml-6 mt-2">
//                 {completedData.mockcall.map((mock, i) => (
//                   <li key={mock._id}>
//                     {new Date(mock.date).toLocaleString()} —{" "}
//                     <strong>{mock.status.toUpperCase()}</strong>:{" "}
//                     {mock.feedback}
//                   </li>
//                 ))}
//               </ul>
//             )}
//             {!completedData && (
//               <div className="mt-2">
//                 <input
//                   type="text"
//                   placeholder="Mock Call Feedback"
//                   className="border p-2 w-full mb-2"
//                   value={mockFeedback}
//                   onChange={(e) => setMockFeedback(e.target.value)}
//                 />
//                 <select
//                   className="border p-2 w-full"
//                   value={mockStatus}
//                   onChange={(e) => setMockStatus(e.target.value)}
//                 >
//                   <option value="pass">Pass</option>
//                   <option value="fail">Fail</option>
//                 </select>
//                 <button
//                   className="bg-blue-500 text-white px-4 py-2 rounded mt-2"
//                   onClick={handleMockCall}
//                 >
//                   Submit Mock Call
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* Attendance */}
//           <h4 className="text-md font-semibold mt-4">Attendance</h4>
//           <div className="grid grid-cols-5 gap-2 mt-2">
//             {[1, 2, 3, 4, 5].map((day, index) => {
//               const status = attendance[index]?.attended;
//               return (
//                 <button
//                   key={index}
//                   className={`px-4 py-2 rounded text-white ${
//                     status === true
//                       ? "bg-green-500"
//                       : status === false
//                       ? "bg-red-500"
//                       : "bg-gray-500"
//                   }`}
//                   onClick={() => markAttendance(day)}
//                 >
//                   Day {day} – {status === true ? "Present" : "Not Marked"}
//                 </button>
//               );
//             })}
//           </div>
//         </div>
//       ) : (
//         <div>
//           <select
//             className="border p-2 w-full mt-2"
//             onChange={(e) => setSelectedTrainer(e.target.value)}
//           >
//             <option value="">Select Trainer</option>
//             {trainers.map((trainer) => (
//               <option key={trainer._id} value={trainer._id}>
//                 {trainer.firstName} {trainer.lastName}
//               </option>
//             ))}
//           </select>
//           <button
//             className="bg-blue-500 text-white px-4 py-2 rounded mt-2"
//             onClick={handleAssignTrainer}
//           >
//             Assign Trainer
//           </button>
//         </div>
//       )}

//       {/* Assign Manager */}
//       {/* {application?.reportingManagerName ? (
//         <>
//           <div className="mt-2">
//             <p className="text-sm text-gray-700">
//               Assigned Manager:{" "}
//               <span className="font-semibold text-blue-600">
//                 {application.reportingManagerName}
//               </span>
//             </p>
//             <button
//               className="mt-2 text-sm text-indigo-600 underline"
//               onClick={() => setShowReassign(true)}
//             >
//               Reassign Manager
//             </button>
//           </div>

//           {showReassign && (
//             <div className="mt-2">
//               <input
//                 type="text"
//                 placeholder="New Manager Name"
//                 className="border p-2 w-full mb-2"
//                 value={manager}
//                 onChange={(e) => setManager(e.target.value)}
//               />
//               <button
//                 className="bg-blue-500 text-white px-4 py-2 rounded"
//                 onClick={handleAssignManager}
//               >
//                 Reassign Manager
//               </button>
//             </div>
//           )}
//         </>
//       ) : (
//         <>
//           <div className="mt-2">
//             <input
//               type="text"
//               placeholder="Manager Name"
//               className="border p-2 w-full mb-2"
//               value={manager}
//               onChange={(e) => setManager(e.target.value)}
//             />
//             <button
//               className="bg-blue-500 text-white px-4 py-2 rounded"
//               onClick={handleAssignManager}
//             >
//               Assign Manager
//             </button>
//           </div>
//         </>
//       )} */}
//     </motion.div>
//   );
// };

export const CreateEmployeeCard = ({
  applicationObjId,
  application,
  userData,
  navigate,
}) => {
  const [reportingManagerName, setReportingManagerName] = useState("");
  const [createdEmployeePopUp, setCreatedEmployeePopUp] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [createdEmployee, setCreatedEmployee] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const swtoken = getCookie("swtoken");

  const [formData, setFormData] = useState({
    personalDetails: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      maritalStatus: "",
      gender: "",
    },
    reportingManagerName: "",
    reportingManagerEmployeeCode: "",
    reportingManagerId: "",
    reportingManagerObjId: "",
    designation: "",
    department: "",
    employeeId: "",
    joiningDate: "",
    offerDetails: {
      workSchedule: "6-day",
      offerLetterDate: "",
      offerAcceptedDate: "",
      joiningDate: "",
      onboardingCompleted: false,
      offerLetterLink: "",
      offerLetterStatus: "pending",
      offerLetterRemarks: "",
      salaryDetails: {
        offeredCTC: 0,
        monthlySalary: 0,
        currency: "INR",
        salaryMode: "monthly",
        components: {
          basic: 0,
          hra: 0,
          special: 0,
          bonus: 0,
          other: 0,
        },
        remarks: "",
      },
    },
  });

  // const handleCreateEmployee = async () => {
  //   // if (!reportingManagerName || !employeeId) {
  //   //   setError("All fields are required.");
  //   //   return;
  //   // }

  //   if (!application?.reportingManagerId || !application?.employeeId) {
  //     setError("All fields are required.");
  //     return;
  //   }

  //   setLoading(true);
  //   setError("");
  //   try {
  //     const res = await axios.post(
  //       `${apiurl}/api/employee/create-from-application`,
  //       {
  //         applicationObjId,
  //         employeeId: application.employeeId,
  //         reportingManagerName: application?.reportingManagerName,
  //         reportingManagerObjId: application?.reportingManagerObjId,
  //         reportingManagerId: application?.reportingManagerId,
  //         offerDetails: formData.offerDetails,
  //       },
  //       {
  //         headers: {
  //           Authorization: swtoken,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     setCreatedEmployee(res.data); // store response to show
  //     if(res.success === true){
  //     toast.success(res.data.message);
  //     } else {
  //     toast.error(res.data.message);
  //     }
  //   } catch (err) {
  //     setError("Failed to create employee.");
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCreateEmployee = async () => {
    if (!application?.reportingManagerId || !application?.employeeId) {
      setError("All fields are required.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res = await axios.post(
        `${apiurl}/api/employee/create-from-application`,
        {
          applicationObjId,
          employeeId: application.employeeId,
          reportingManagerName: application?.reportingManagerName,
          reportingManagerObjId: application?.reportingManagerObjId,
          reportingManagerId: application?.reportingManagerId,
          offerDetails: formData.offerDetails,
        },
        {
          headers: {
            Authorization: swtoken,
            "Content-Type": "application/json",
          },
        }
      );

      setCreatedEmployee(res.data); // store response to show

      // ✅ Fix: check success from res.data, not res
      if (res.data.success === true) {
        toast.success(res.data.message);
        navigate(`/employees/${res?.data?.employee?._id}`);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (err) {
      setError("Failed to create employee.");
      console.error(err);
      toast.error(
        err.response?.data?.message || "Failed to create employee. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const calculateSalaryComponents = (monthlySalary) => {
    const salary = parseFloat(monthlySalary);
    if (isNaN(salary) || salary <= 0) {
      return {
        offeredCTC: 0,
        basic: 0,
        hra: 0,
        other: 0,
      };
    }

    const offeredCTC = Math.round(salary * 12);
    const basic = Math.round(salary * 0.2);
    const hra = Math.round(basic * 0.5);
    const other = Math.round(salary - basic - hra);

    return {
      offeredCTC,
      basic,
      hra,
      other,
    };
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4 mt-6">
      <h3 className="text-xl font-semibold mb-4">Create Employee</h3>

      {createdEmployee ? (
        <div className="text-green-600 font-medium">
          ✅ Employee Created:
          <div className="mt-2">
            {/* <p><strong>ID:</strong> {createdEmployee.employeeId}</p>
            <p><strong>Manager:</strong> {createdEmployee.reportingManagerName}</p> */}
          </div>
        </div>
      ) : (
        <>
          {error && <p className="text-red-500 text-sm">{error}</p>}

          {/* <button
            className="bg-blue-600 text-white px-4 py-2 rounded mt-2"
            onClick={handleCreateEmployee}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Employee"}
          </button> */}

          {/* <button
            className="bg-red-600 mx-3 text-white px-4 py-2 rounded mt-2"
            onClick={() => setCreatedEmployeePopUp(true)}
          >
           Create Employee
          </button> */}
          <button
            className="bg-green-600 text-white px-4 py-2 rounded mt-2"
            onClick={() => setCreatedEmployeePopUp(true)}
          >
            Create Employee
          </button>

          {createdEmployeePopUp === true ? (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-md w-[90%] max-w-4xl overflow-auto max-h-[90vh]">
                <div className="flex justify-between items-center">
                  <h2 className="text-lg font-semibold ">Create Employee</h2>
                  <button
                    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition"
                    onClick={() => setCreatedEmployeePopUp(false)}
                  >
                    Close
                  </button>
                </div>
                <div className="bg-white border rounded-xl p-6 w-full hover:shadow-lg my-2">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold text-gray-800">
                      Personal Details
                    </h2>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <p>
                      <strong>Application ID:</strong> {application?.id}
                    </p>
                    <p>
                      <strong>Aadhar Number:</strong>{" "}
                      {application?.candidateSnapshot?.aadharNumber}
                    </p>
                    <p>
                      <strong>Name:</strong>{" "}
                      {application?.candidateSnapshot?.firstName}{" "}
                      {application?.candidateSnapshot?.lastName}
                    </p>
                    <p>
                      <strong>Email:</strong>{" "}
                      {application?.candidateSnapshot?.email}
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      {application?.candidateSnapshot?.phone}
                    </p>
                    <p>
                      <strong>DOB:</strong>{" "}
                      {application?.candidateSnapshot?.dateOfBirth}
                    </p>
                  </div>
                </div>
                <div className="bg-white border rounded-xl p-6 w-full hover:shadow-lg my-2">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold text-gray-800">
                      Reporting Details
                    </h2>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <p>
                      <strong>Position:</strong> {application?.positionTitle}
                    </p>
                    <p>
                      <strong>Department:</strong> {application?.department}
                    </p>
                    <p>
                      <strong>Joining Date:</strong>{" "}
                      <span className="text-blue-600">
                        {application?.offerDetails?.joiningDate}
                        {/* {dayjs(application?.offerDetails?.joiningDate).format(
                          "DD MMM YYYY"
                        )} */}
                      </span>
                    </p>
                    <p>
                      <strong>Employee ID:</strong> SUW
                      {application?.employeeId}
                    </p>
                    <p>
                      <strong>Manager Name:</strong>{" "}
                      {application?.reportingManagerName}
                    </p>
                    <p>
                      <strong>Manager ID:</strong> SUW
                      {application?.reportingManagerId}
                    </p>
                  </div>
                </div>
                <div className="bg-white border rounded-xl p-6 w-full hover:shadow-lg my-2">
                  <div className="flex justify-between items-center">
                    <h2 className="text-lg font-semibold mb-4">
                      Offer & Salary Details
                    </h2>
                  </div>

                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">
                        Work Schedule
                      </label>
                      <select
                        value={formData.offerDetails.workSchedule}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            offerDetails: {
                              ...prev.offerDetails,
                              workSchedule: e.target.value,
                            },
                          }))
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        {/* <option value="">Select </option> */}
                        <option value="6-day">6-day</option>
                        <option value="5-day">5-day</option>
                        <option value="rotational">Rotational</option>
                      </select>
                    </div>

                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">
                        Monthly Salary
                      </label>
                      <input
                        type="number"
                        value={
                          formData.offerDetails.salaryDetails?.monthlySalary ||
                          0
                        }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          const calculated = calculateSalaryComponents(value);

                          setFormData((prev) => ({
                            ...prev,
                            offerDetails: {
                              ...prev.offerDetails,
                              salaryDetails: {
                                ...prev.offerDetails.salaryDetails,
                                monthlySalary: value,
                                offeredCTC: calculated.offeredCTC,
                                components: {
                                  ...prev.offerDetails.salaryDetails.components,
                                  basic: calculated.basic,
                                  hra: calculated.hra,
                                  other: calculated.other,
                                },
                              },
                            },
                          }));
                        }}
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Offered CTC (Yearly)
                      </label>
                      <input
                        type="number"
                        value={
                          formData.offerDetails.salaryDetails?.offeredCTC || 0
                        }
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            offerDetails: {
                              ...prev.offerDetails,
                              salaryDetails: {
                                ...prev.offerDetails.salaryDetails,
                                offeredCTC: Number(e.target.value),
                              },
                            },
                          }))
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Currency
                      </label>
                      <input
                        type="text"
                        readOnly
                        value={
                          formData.offerDetails.salaryDetails?.currency || ""
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Salary Mode
                      </label>
                      <input
                        type="text"
                        readOnly
                        value={
                          formData.offerDetails.salaryDetails?.salaryMode || ""
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Basic
                      </label>
                      <input
                        type="number"
                        // value={calculateSalaryComponents(
                        //   formData.offerDetails.salaryDetails?.monthlySalary
                        // ).basic.toFixed(2)}
                        value={
                          formData.offerDetails.salaryDetails.components.basic
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        HRA
                      </label>
                      <input
                        type="number"
                        // value={calculateSalaryComponents(
                        //   formData.offerDetails.salaryDetails?.monthlySalary
                        // ).hra.toFixed(2)}
                        value={
                          formData.offerDetails.salaryDetails.components.hra
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Special
                      </label>
                      <input
                        type="number"
                        value={
                          formData.offerDetails.salaryDetails?.components
                            ?.special || 0
                        }
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            offerDetails: {
                              ...prev.offerDetails,
                              salaryDetails: {
                                ...prev.offerDetails.salaryDetails,
                                components: {
                                  ...prev.offerDetails.salaryDetails
                                    ?.components,
                                  special: Number(e.target.value),
                                },
                              },
                            },
                          }))
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Bonus
                      </label>
                      <input
                        type="number"
                        value={
                          formData.offerDetails.salaryDetails?.components
                            ?.bonus || 0
                        }
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            offerDetails: {
                              ...prev.offerDetails,
                              salaryDetails: {
                                ...prev.offerDetails.salaryDetails,
                                components: {
                                  ...prev.offerDetails.salaryDetails
                                    ?.components,
                                  bonus: Number(e.target.value),
                                },
                              },
                            },
                          }))
                        }
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Other
                      </label>
                      <input
                        type="number"
                        // value={calculateSalaryComponents(
                        //   formData.offerDetails.salaryDetails?.monthlySalary
                        // ).other.toFixed(2)}
                        value={
                          formData.offerDetails.salaryDetails.components.other
                        }
                        readOnly
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div className="col-span-2">
                      <label className="text-sm font-medium text-gray-700">
                        Salary Remarks
                      </label>
                      <textarea
                        placeholder="Salary Remarks"
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={
                          formData.offerDetails.salaryDetails?.remarks || ""
                        }
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            offerDetails: {
                              ...prev.offerDetails,
                              salaryDetails: {
                                ...prev.offerDetails.salaryDetails,
                                remarks: e.target.value,
                              },
                            },
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="flex">
                  <button
                    className="bg-blue-600 text-white px-4 py-2 rounded mt-2"
                    onClick={handleCreateEmployee}
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create Employee"}
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export const ReferenceDetailsForm = ({ applicationObjId, onStatusChange }) => {
  const [formData, setFormData] = useState({ referenceType: "" });
  const [recruiters, setRecruiters] = useState([]);

  const referenceTypes = [
    { label: "Walk-in", value: "walkin" },
    { label: "HR", value: "recruiter" },
    { label: "Employee Reference", value: "employee" },
    { label: "Consultancy", value: "consultancy" },
    { label: "Other", value: "other" },
  ];

  useEffect(() => {
    fetchRecruiters();
  }, []);

  const fetchRecruiters = async () => {
    try {
      const response = await axios.post(`${apiurl}/api/user/getbyrole`, {
        role: "recruiter",
        status: "active",
      });
      if (response.data.success) {
        setRecruiters(response.data.users);
      }
    } catch (err) {
      console.error("Error fetching recruiters:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const buildCleanPayload = () => {
    const { referenceType } = formData;
    const base = { referenceType };

    switch (referenceType) {
      case "recruiter":
        return {
          ...base,
          recruiterName: formData.recruiterName || "",
          recruiterId: formData.recruiterId || "",
        };
      case "employee":
        return {
          ...base,
          employeeName: formData.employeeName || "",
          employeeId: formData.employeeId || "",
        };
      case "consultancy":
        return {
          ...base,
          consultancyReference: formData.consultancyReference || "",
        };
      case "other":
        return {
          ...base,
          otherReference: formData.otherReference || "",
        };
      case "walkin":
        return {
          ...base,
          walkInReference: formData.walkInReference || "",
        };
      default:
        return base;
    }
  };

  const handleSubmit = async () => {
    try {
      const payload = buildCleanPayload();
      await axios.post(
        `${apiurl}/api/application/updateReferenceDetails/${applicationObjId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      alert("Reference details updated successfully.");
      onStatusChange && onStatusChange();
    } catch (err) {
      console.error(err);
      alert("Error updating reference details.");
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow mt-6">
      <h3 className="text-lg font-semibold mb-4">Update Reference Details</h3>

      <label className="block mb-2 text-sm font-medium">Reference Type</label>
      <select
        name="referenceType"
        value={formData.referenceType}
        onChange={(e) => {
          const val = e.target.value;
          setFormData({ referenceType: val });
        }}
        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
        required
      >
        <option value="">Select Reference Type</option>
        {referenceTypes.map((ref) => (
          <option key={ref.value} value={ref.value}>
            {ref.label}
          </option>
        ))}
      </select>

      {/* Dynamic Fields */}
      {formData.referenceType === "employee" && (
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <input
            type="text"
            name="employeeName"
            placeholder="Employee Name"
            value={formData.employeeName || ""}
            onChange={handleChange}
            className="w-full p-3 border rounded-xl"
          />
          <input
            type="text"
            name="employeeId"
            placeholder="Employee ID"
            value={formData.employeeId || ""}
            onChange={handleChange}
            className="w-full p-3 border rounded-xl"
          />
        </div>
      )}

      {formData.referenceType === "recruiter" && (
        <div className="mt-4">
          <select
            className="w-full p-3 border rounded-xl"
            value={formData.recruiterId || ""}
            onChange={(e) => {
              const selected = recruiters.find(
                (r) => r?.employeeDetails?.employeeId === e.target.value
              );
              setFormData({
                referenceType: "recruiter",
                recruiterId: selected?.employeeDetails?.employeeId || "",
                recruiterName: `${selected?.firstName || ""} ${
                  selected?.lastName || ""
                }`,
              });
            }}
          >
            <option value="">Select HR</option>
            {recruiters.map((recruiter) => (
              <option
                key={recruiter?._id}
                value={recruiter?.employeeDetails?.employeeId}
              >
                {recruiter?.firstName} {recruiter?.lastName}
              </option>
            ))}
          </select>
        </div>
      )}

      {formData.referenceType === "consultancy" && (
        <div className="mt-4">
          <label className="block mb-2 font-semibold">
            Consultancy Company Name
          </label>
          <select
            name="consultancyReference"
            value={formData.consultancyReference || ""}
            onChange={handleChange}
            className="w-full p-3 border rounded-xl"
          >
            <option value="">-- Select Name --</option>
            <option value="touchcore-consultancy">Touchcore Consultancy</option>
            <option value="krishna-consultancy">Krishna Consultancy</option>
            <option value="tr-consultancy">TR Consultancy</option>
            <option value="ahrs-consultancy">AHRS Consultancy</option>
            <option value="uplevel-solutions">Uplevel Solutions</option>
            <option value="talent-genics">Talent Genics</option>
            <option value="hirosity-consultancy">Hirosity Consultancy</option>
            <option value="enlabs-technology">Enlabs Technology</option>
          </select>
        </div>
      )}

      {formData.referenceType === "other" && (
        <div className="mt-4">
          <textarea
            name="otherReference"
            placeholder="Describe Reference"
            value={formData.otherReference || ""}
            onChange={handleChange}
            className="w-full p-3 border rounded-xl"
          />
        </div>
      )}

      {formData.referenceType === "walkin" && (
        <div className="mt-4">
          <input
            type="text"
            name="walkInReference"
            placeholder="Walk-in Reference"
            value={formData.walkInReference || ""}
            onChange={handleChange}
            className="w-full p-3 border rounded-xl"
          />
        </div>
      )}

      <button
        onClick={handleSubmit}
        className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
      >
        Update Reference
      </button>
    </div>
  );
};

const AddRemarkForm = ({
  applicationObjId,
  userObjId,
  onStatusChange,
  application,
}) => {
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!remarks.trim()) return;

    setLoading(true);
    try {
      const res = await axios.post(`${apiurl}/api/application/add-remarks`, {
        applicationObjId,
        userObjId,
        remarks,
      });

      setMessage("Remark added successfully");
      setRemarks("");
      onStatusChange && onStatusChange();
    } catch (err) {
      setMessage(err.response?.data?.message || "Error adding remark");
      onStatusChange && onStatusChange();
    } finally {
      setLoading(false);
      onStatusChange && onStatusChange();
    }
  };

  return (
    <div className="bg-white border rounded-xl p-6 w-full hover:shadow-lg my-2">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Remarks</h2>
      <form onSubmit={handleSubmit} className="w-full  space-y-4">
        <input
          className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
          rows={4}
          placeholder="Write a remark..."
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Add Remark"}
        </button>

        {message && <p className="text-sm text-gray-600">{message}</p>}
      </form>

      <div className="space-y-4">
        <h2 className="text-lg mt-3 font-semibold">Previous Remarks</h2>
        {application?.remarks.length === 0 ? (
          <p className="text-gray-500">No remarks added yet.</p>
        ) : (
          application?.remarks.map((remark) => (
            <div key={remark._id} className="border p-3 rounded-md bg-gray-50">
              <p className="text-gray-800">
                <span className="font-medium">By:</span>{" "}
                {remark?.addedBy?.userName || "Unknown"}
              </p>
              <p className="text-gray-600 text-sm">
                <span className="font-medium">On:</span>{" "}
                {dayjs(remark.date).format("DD MMM YYYY, hh:mm A")}
              </p>
              {remark.remarks && (
                <p className="mt-2 text-gray-700">{remark.remarks}</p>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const EmployeeIdAssignCard = ({ applicationObjId, application, onStatusChange }) => {
  const [employeeId, setEmployeeId] = useState("");
  const [showReassignId, setShowReassignId] = useState(false);

  const handleAssignEmployeeId = async () => {
    if (!employeeId) {
      toast.error("Please enter Employee ID");
      return;
    }

    try {
      await axios.post(
        `${apiurl}/api/application/move-onboarding`,
        {
          applicationObjIds: [applicationObjId],
          employeeId,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success("Employee ID assigned successfully");
      onStatusChange && onStatusChange();
      setEmployeeId("");
      setShowReassignId(false);
    } catch (err) {
      console.error("Error assigning Employee ID:", err);
      toast.error("Failed to assign Employee ID");
    }
  };

  const handleInputChange = (e) => {
    // Only allow numeric input
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setEmployeeId(value);
    } else {
      toast.error("Only numeric values are allowed");
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-6 w-full hover:shadow-lg transition-shadow duration-300 my-4">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Assign Employee ID</h2>

      {application?.employeeId ? (
        <>
          <div className="flex items-center justify-between mb-4">
            <p className="text-sm text-gray-700">
              Employee ID:{" "}
              <span className="font-semibold text-blue-600">{application.employeeId}</span>
            </p>
            <button
              className="text-sm text-indigo-600 hover:text-indigo-800 underline"
              onClick={() => setShowReassignId(!showReassignId)}
            >
              {showReassignId ? "Cancel" : "Reassign"}
            </button>
          </div>

          {showReassignId && (
            <div className="flex flex-col gap-3">
              <input
                type="text"
                placeholder="Enter Numeric Employee ID"
                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={employeeId}
                onChange={handleInputChange}
              />
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded-lg font-semibold transition"
                onClick={handleAssignEmployeeId}
              >
                Assign Employee ID
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="flex flex-col gap-3">
          <input
            type="text"
            placeholder="Enter Numeric Employee ID"
            className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={employeeId}
            onChange={handleInputChange}
          />
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded-lg font-semibold transition"
            onClick={handleAssignEmployeeId}
          >
            Assign Employee ID
          </button>
        </div>
      )}
    </div>
  );
};


const ExperienceCard = ({ application, applicationObjId, onStatusChange }) => {
  const swtoken = getCookie("swtoken");
  const [showPopup, setShowPopup] = useState(false);
  const [form, setForm] = useState(
    application.professionalInfo || {
      experienceType: "experienced",
      skills: [],
      totalExperience: 0,
      relevantExperience: 0,
      process: "",
      previousCompany: "",
      reasonForLeaving: "",
      currentCTC: 0,
      noticePeriod: "",
    }
  );
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);
      await axios.post(
        `${apiurl}/api/application/add-experience`,
        {
          applicationObjId, // single object
          experienceDetails: form,
        },
        {
          headers: {
            Authorization: swtoken,
          },
        }
      );
      onStatusChange && onStatusChange();
      setShowPopup(false);
    } catch (err) {
      console.error("Failed to save experience", err);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async () => {
    try {
      setLoading(true);
      await axios.post(
        `${apiurl}/api/application/remove-experience`,
        {
          applicationObjId, // single object
        },
        {
          headers: {
            Authorization: swtoken,
          },
        }
      );
      onStatusChange && onStatusChange();
    } catch (err) {
      console.error("Failed to remove experience", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4 my-6">
      <h3 className="text-xl font-semibold mb-2">Experience Details</h3>

      {!application.professionalInfo ? (
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={() => setShowPopup(true)}
        >
          Add Experience
        </button>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <p>
              <strong>Total Experience:</strong> {form.totalExperience} yrs
            </p>
            <p>
              <strong>Relevant Experience:</strong> {form.relevantExperience}{" "}
              yrs
            </p>
            <p>
              <strong>Previous Company:</strong> {form.previousCompany}
            </p>
            <p>
              <strong>Process:</strong> {form.process}
            </p>
            <p>
              <strong>Current CTC:</strong> ₹{form.currentCTC}
            </p>
            <p>
              <strong>Notice Period:</strong> {form.noticePeriod}
            </p>
            <p className="col-span-2">
              <strong>Reason for Leaving:</strong> {form.reasonForLeaving}
            </p>
            <p className="col-span-2">
              <strong>Skills:</strong> {form.skills.join(", ")}
            </p>
          </div>

          <div className="flex gap-3 mt-4">
            <button
              onClick={() => setShowPopup(true)}
              className="bg-yellow-500 text-white px-3 py-2 rounded"
            >
              Edit Experience
            </button>
            <button
              onClick={handleRemove}
              className="bg-red-600 text-white px-3 py-2 rounded"
            >
              {loading ? "Removing..." : "Remove Experience"}
            </button>
          </div>
        </>
      )}

      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-[90%] max-w-3xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">
                {application.professionalInfo
                  ? "Edit Experience"
                  : "Add Experience"}
              </h2>
              <button
                className="bg-gray-500 text-white px-3 py-1 rounded"
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-semibold">
                  Total Experience (years)
                </label>
                <input
                  type="number"
                  value={form.totalExperience}
                  onChange={(e) =>
                    setForm({ ...form, totalExperience: e.target.value })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="text-sm font-semibold">
                  Relevant Experience (years)
                </label>
                <input
                  type="number"
                  value={form.relevantExperience}
                  onChange={(e) =>
                    setForm({ ...form, relevantExperience: e.target.value })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="text-sm font-semibold">
                  Previous Company
                </label>
                <input
                  type="text"
                  value={form.previousCompany}
                  onChange={(e) =>
                    setForm({ ...form, previousCompany: e.target.value })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="text-sm font-semibold">Process</label>
                <input
                  type="text"
                  value={form.process}
                  onChange={(e) =>
                    setForm({ ...form, process: e.target.value })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="text-sm font-semibold">Current CTC</label>
                <input
                  type="number"
                  value={form.currentCTC}
                  onChange={(e) =>
                    setForm({ ...form, currentCTC: e.target.value })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="text-sm font-semibold">Notice Period</label>
                <input
                  type="text"
                  value={form.noticePeriod}
                  onChange={(e) =>
                    setForm({ ...form, noticePeriod: e.target.value })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
              <div className="col-span-2">
                <label className="text-sm font-semibold">
                  Reason for Leaving
                </label>
                <input
                  type="text"
                  value={form.reasonForLeaving}
                  onChange={(e) =>
                    setForm({ ...form, reasonForLeaving: e.target.value })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
              <div className="col-span-2">
                <label className="text-sm font-semibold">
                  Skills (comma-separated)
                </label>
                <input
                  type="text"
                  value={form.skills.join(", ")}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      skills: e.target.value.split(",").map((s) => s.trim()),
                    })
                  }
                  className="w-full p-2 border rounded"
                />
              </div>
            </div>
            <div className="mt-4 flex justify-end">
              <button
                onClick={handleSave}
                className="bg-green-600 text-white px-4 py-2 rounded"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Experience"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const InfoItem = ({ icon, label, value }) => (
  <div className="flex items-start gap-2">
    <div className="text-gray-500">{icon}</div>
    <div>
      <dt className="text-gray-500 text-xs uppercase">{label}</dt>
      <dd className="text-gray-800 font-medium">{value || "N/A"}</dd>
    </div>
  </div>
);